export const LOGOUT = require("src/components/api/helper/apiHelper").logout;
